import { Component, IterableDiffers, Input, EventEmitter, Output, AfterViewInit } from '@angular/core';
import { DualListComponent } from 'angular-dual-listbox';

@Component({
  selector: 'dual-list-custom',
  templateUrl: './dual-list-custom.component.html',
  styleUrls: ['./dual-list-custom.component.scss'],
})
export class DualListCustomComponent extends DualListComponent implements AfterViewInit {
  @Input() label1 = '';
  @Input() label2 = '';
  @Input() respostaControl: boolean = false;
  @Input() campoRequerido: boolean = false;
  @Input() verDescricaoPontosLinha: boolean = false;

  @Output() childReference = new EventEmitter();
  @Output() selectChange = new EventEmitter();

  descricao: string;
  constructor(differs: IterableDiffers) {
    super(differs);
  }

  ngAfterViewInit() {
    this.childReference.emit(this.confirmed);
  }
  // Allow for complex names by passing an array of strings.
  // Example: [display]="[ '_type.substring(0,1)', '_name' ]"
  protected makeName(item: any, separator = ' - '): string {
    const display = this.display;

    function fallback(itm: any) {
      switch (Object.prototype.toString.call(itm)) {
        case '[object Number]':
          return itm;
        case '[object String]':
          return itm;
        default:
          if (itm !== undefined) {
            return itm[display];
          } else {
            return 'undefined';
          }
      }
    }

    let str = '';

    if (this.display !== undefined) {
      switch (Object.prototype.toString.call(this.display)) {
        case '[object Function]':
          str = this.display(item);
          break;

        case '[object Array]':
          for (let i = 0, len = this.display.length; i < len; i += 1) {
            if (str.length > 0) {
              str = str + separator;
            }

            if (this.display[i].indexOf('.') === -1) {
              // Simple, just add to string.
              str = str + item[this.display[i]];
            } else {
              // Complex, some action needs to be performed
              const parts = this.display[i].split('.');

              const s = item[parts[0]];
              if (s) {
                // Use brute force
                if (parts[1].indexOf('substring') !== -1) {
                  const nums = parts[1].substring(parts[1].indexOf('(') + 1, parts[1].indexOf(')')).split(',');

                  switch (nums.length) {
                    case 1:
                      str = str + s.substring(parseInt(nums[0], 10));
                      break;
                    case 2:
                      str = str + s.substring(parseInt(nums[0], 10), parseInt(nums[1], 10));
                      break;
                    default:
                      str = str + s;
                      break;
                  }
                } else {
                  // method not approved, so just add s.
                  str = str + s;
                }
              }
            }
          }
          break;
        default:
          str = fallback(item);
          break;
      }
    } else {
      str = fallback(item);
    }

    return str;
  }
}
